import React, { useState, useEffect } from 'react';
import '../../styles/auth.css';
import { useNavigate } from "react-router-dom";
import { t } from '../../services/translationService';
import { OfficeLoginT } from '../../services/LanguageTranslationService';
import ReCAPTCHA from 'react-google-recaptcha';
const OfficeLogin = ({ onClose }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });

  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [apiMessage, setApiMessage] = useState({ text: '', isError: false });
  const [captchaValue, setCaptchaValue] = useState(null);
  // ESC key handler
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape' && !isLoading && !showSuccess) onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose, isLoading, showSuccess]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };
  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
    console.log("Captcha value:", value);
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.username.trim()) {
      newErrors.username = OfficeLoginT('officeLogin.errors.usernameRequired');
    }

    if (!formData.password) {
      newErrors.password = OfficeLoginT('officeLogin.errors.passwordRequired');
    } else if (formData.password.length < 6) {
      newErrors.password = OfficeLoginT('officeLogin.errors.passwordLength');
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    //if (!captchaValue) {
    //  alert('Please complete the CAPTCHA');
    //  return;
    //}
    if (!validate()) return;

    setIsLoading(true);
    setApiMessage({ text: '', isError: false });

    console.log("send");
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/login_office.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
        credentials: "include",
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || OfficeLoginT('officeLogin.errors.loginFailed'));
      }

      if (result.status === "success") {
        localStorage.setItem("token_office", result.token);
        setShowSuccess(true);
        
        setApiMessage({ 
          text: t('officeLogin.successMessage'), 
          isError: false 
        });
        
        setTimeout(() => {
          onClose();
          if (result.redirect) {
            navigate(result.redirect);
          }
        }, 1500);
      } else {
        throw new Error(result.message || OfficeLoginT('officeLogin.errors.invalidCredentials'));
      }
    } catch (error) {
      setApiMessage({ 
        text: error.message, 
        isError: true 
      });
      setErrors((prev) => ({ ...prev, general: error.message }));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container" onClick={(e) => e.target === e.currentTarget && !isLoading && !showSuccess && onClose()}>
      <div className="auth-box">
        <div className="auth-header">
          <h2 className="auth-title">{OfficeLoginT('officeLogin.title')}</h2>
          <button
            className="close-button"
            onClick={onClose}
            aria-label={OfficeLoginT('officeLogin.closeButton')}
            disabled={isLoading || showSuccess}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {apiMessage.text && (
            <div className={`${apiMessage.isError ? 'error-message' : 'success-message'}`} style={{ textAlign: 'center', marginBottom: '1rem' }}>
              {apiMessage.isError ? (
                <>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                  </svg>
                  <span>{apiMessage.text}</span>
                </>
              ) : (
                <>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                  <span>{apiMessage.text}</span>
                </>
              )}
            </div>
          )}

          <div className={`form-group ${errors.username ? 'error' : ''}`}>
            <label htmlFor="username">{OfficeLoginT('officeLogin.emailLabel')}</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder={OfficeLoginT('officeLogin.emailPlaceholder')}
              autoComplete="username"
              disabled={isLoading || showSuccess}
            />
            {errors.username && <span className="error-message">{errors.username}</span>}
          </div>

          <div className={`form-group ${errors.password ? 'error' : ''}`}>
            <label htmlFor="password">{OfficeLoginT('officeLogin.passwordLabel')}</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder={OfficeLoginT('officeLogin.passwordPlaceholder')}
              autoComplete="current-password"
              disabled={isLoading || showSuccess}
            />
            {errors.password && <span className="error-message">{errors.password}</span>}
          </div>
       {/* reCAPTCHA Widget 
          <ReCAPTCHA
            sitekey='6LfYwAsrAAAAAKwbAzAomjZoUhEXXx3EDBmIqyht'
            onChange={handleCaptchaChange}
          />
*/}
          <div className="auth-buttons">
            <button
              type="submit"
              className={`submit-button ${isLoading ? 'loading' : ''}`}
              disabled={isLoading || showSuccess}
            >
              {isLoading ? (
                <>
                
                  {OfficeLoginT('officeLogin.loggingIn')}
                </>
              ) : (
                OfficeLoginT('officeLogin.loginButton')
              )}
            </button>
            <button
              type="button"
              className="cancel-button"
              onClick={onClose}
              disabled={isLoading || showSuccess}
            >
              {t('officeLogin.cancelButton')}
            </button>
          </div>

          <div className="auth-links">
            {/* 
            <a
              href="#forgot-password"
              className="forgot-password"
              onClick={(e) => {
                e.preventDefault();
                console.log('Forgot password clicked');
              }}
              style={{ pointerEvents: isLoading || showSuccess ? 'none' : 'auto' }}
            >
              {t('officeLogin.forgotPassword')}
            </a>
            */}
          </div>
        </form>
      </div>
    </div>
  );
};

export default OfficeLogin;